import { useGetPartnerUserDetails } from '@dazn/lp-web/src/hooks/useGetPartnerUserDetails';
import { useState, useEffect } from 'react';

interface PartnerUserData {
    isAlreadyLinked: boolean | null;
    nextAction: string;
    isDaznUserExist: boolean;
    isPartnerUserExist: boolean;
    [key: string]: any;
}

// interface UseCanalPlusReturn {
//     partnerUserData: PartnerUserData | null;
//     authorizationCode: string;
//     isNotSubscribedUser: boolean;
//     isFetchingPartnerUserDetails: boolean;
// }
export const useAmazonLogin = ({ amazonAuthorizationCode }: { amazonAuthorizationCode: any }): any => {

    const [shouldFetchPartnerData, setShouldFetchPartnerData] = useState(false);

    useEffect(() => {
        if (amazonAuthorizationCode) {
            setShouldFetchPartnerData(true);
        }
    }, [amazonAuthorizationCode]);

    const { partnerUserData: apiData, isFetchingPartnerUserDetails, statusCode } =
        useGetPartnerUserDetails({
            responseCode: shouldFetchPartnerData ? amazonAuthorizationCode : ''
        }) ?? {};

    const amazonPartnerUserData: PartnerUserData | null = apiData
        ? {
            isAlreadyLinked: apiData.isAlreadyLinked || null,
            nextAction: apiData.nextAction || '',
            isDaznUserExist: apiData.isDaznUserExist || false,
            isPartnerUserExist: apiData.isPartnerUserExist || false,
            ...apiData
        }
        : null;

    return {
        amazonPartnerUserData,
        isFetchingAmazonPartnerDetails: isFetchingPartnerUserDetails,
        statusCode
    };
};
